var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn",class:_vm.darkModeBtn,on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Go Back")])])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }